import type { CSSProperties, InputHTMLAttributes, ReactNode } from "react";

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "prefix"> {
  value: string | number;
  onChange?: (v: string) => void;
  prefix?: ReactNode;
  containerStyle?: CSSProperties;
}

export function Input({ value, onChange, prefix, containerStyle, ...rest }: Props) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        border: "1px solid var(--line)",
        borderRadius: 10,
        background: "var(--bg)",
        padding: "0 12px",
        ...containerStyle,
      }}
    >
      {prefix && <span style={{ color: "var(--ink-soft)" }}>{prefix}</span>}
      <input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        style={{
          flex: 1,
          padding: "12px 0",
          border: "none",
          outline: "none",
          fontFamily: "var(--ui)",
          fontSize: 15,
          color: "var(--ink)",
          background: "transparent",
        }}
        {...rest}
      />
    </div>
  );
}
